import { render, staticRenderFns } from "./addDashboard.vue?vue&type=template&id=0c29b9fa&scoped=true"
import script from "./addDashboard.vue?vue&type=script&lang=js"
export * from "./addDashboard.vue?vue&type=script&lang=js"
import style0 from "./addDashboard.vue?vue&type=style&index=0&id=0c29b9fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c29b9fa",
  null
  
)

export default component.exports